export enum OrganizationsTableAccessor {
  Icon = 'iconUrl',
  Name = 'name',
  TaxId = 'registrationNo',
  Url = 'url',
}
